var geography = function(btn){
	var frame = document.querySelector('[data-geography-frame]'),
        contriesFrame = null,
        contriesToggleBtn = null,
		frameInner = undefined,
		chooseCity = undefined,
		closeBtn = undefined,
		xhr = undefined,
		modules = undefined,
		isLoaded = false,
		path = APP.vars.isDev ? "/_src/layouts/desktop/_pieces/geography.php" : '/service/header/',
		showHat = function(){
			if(isLoaded) openHat();
			else getData();
		},
		getData = function(){
			btn.classList.add('js-loading');
			xhr = new XMLHttpRequest();
			xhr.open("POST", path, true);
			xhr.setRequestHeader("X-Request-Ajax","1");
			xhr.onload = addData;
			xhr.send('');
		},
		addData = function(){
			frame.innerHTML = xhr.responseText;
			frameInner = frame.querySelector('[data-js="frame"]');
			chooseCity = frame.querySelector('.chooseCity');
			closeBtn = frame.querySelector('[data-js="close"]');
			modules = APP.modules.run(frame, 'data-geography-modules');
			closeBtn.addEventListener('click', closeHat);
			btn.classList.remove('js-loading');
			isLoaded = true;
			openHat();
		},
        toggleBtnHandler = function (e) {
            e.preventDefault();
            contriesFrame.classList.toggle('as-none');
            chooseCity.style.height = frameInner.getBoundingClientRect().height + 'px';
        },
		openHat = function(){
			frame.classList.add('js-active');
			chooseCity.style.height = frameInner.getBoundingClientRect().height + 'px';
			btn.classList.add('js-active');
            contriesFrame = document.querySelector('[data-geography-contriesFrame]');
            contriesToggleBtn = document.querySelector('[data-geography-contriesToggleBtn]');
			if ( contriesToggleBtn && contriesFrame ) {
                contriesToggleBtn.addEventListener('click',toggleBtnHandler);
			}

		},
		closeHat = function(){
			frame.classList.remove('js-active');
			btn.classList.remove('js-active');
            if ( contriesToggleBtn && contriesFrame ) {
                contriesToggleBtn.removeEventListener('click', toggleBtnHandler);
            }
		},
		toggleHat = function(e){
			e.preventDefault();
			if(this.classList.contains('js-loading')) return;
			else if(this.classList.contains('js-active')) closeHat();
			else showHat();
		};
	//
	btn.addEventListener('click', toggleHat);

}

export {geography};
